import React, { useEffect, useRef } from 'react';
import '../styles/AttachmentMenu.css';

function AttachmentMenu({ onOptionClick, onClose }) {
  const menuRef = useRef(null);
  
  const attachmentOptions = [
    { 
      id: 'photos', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="#ff6b6b" stroke="#ff6b6b" strokeWidth="2"/>
          <circle cx="9" cy="9" r="2" fill="#ffffff"/>
          <polyline points="21,15 16,10 5,21" stroke="#ffffff" strokeWidth="2"/>
        </svg>
      ), 
      label: 'Gallery' 
    },
    { 
      id: 'camera', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" fill="#4ecdc4" stroke="#4ecdc4" strokeWidth="2"/>
          <circle cx="12" cy="13" r="4" fill="#ffffff" stroke="#ffffff" strokeWidth="2"/>
        </svg>
      ), 
      label: 'Camera' 
    },
    { 
      id: 'document', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" fill="#45b7d1" stroke="#45b7d1" strokeWidth="2"/>
          <polyline points="14,2 14,8 20,8" fill="#ffffff" stroke="#ffffff" strokeWidth="2"/>
          <line x1="16" y1="13" x2="8" y2="13" stroke="#ffffff" strokeWidth="2"/>
          <line x1="16" y1="17" x2="8" y2="17" stroke="#ffffff" strokeWidth="2"/>
        </svg>
      ), 
      label: 'Document' 
    },
    { 
      id: 'location', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" fill="#f39c12" stroke="#f39c12" strokeWidth="2"/>
          <circle cx="12" cy="10" r="3" fill="#ffffff"/>
        </svg>
      ), 
      label: 'Location' 
    },
    { 
      id: 'contact', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="7" r="4" fill="#9b59b6" stroke="#9b59b6" strokeWidth="2"/>
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" fill="#9b59b6" stroke="#9b59b6" strokeWidth="2"/>
        </svg>
      ), 
      label: 'Contact' 
    },
    { 
      id: 'audio', 
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z" fill="#e74c3c" stroke="#e74c3c" strokeWidth="2"/>
          <path d="M19 10v2a7 7 0 01-14 0v-2" stroke="#e74c3c" strokeWidth="2"/>
          <line x1="12" y1="19" x2="12" y2="23" stroke="#e74c3c" strokeWidth="2"/>
          <line x1="8" y1="23" x2="16" y2="23" stroke="#e74c3c" strokeWidth="2"/>
        </svg>
      ), 
      label: 'Audio' 
    }
  ];

  const handleOptionClick = (optionId) => {
    onOptionClick(optionId);
    onClose();
  };

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="attachment-menu" ref={menuRef}>
      {attachmentOptions.map((option) => (
        <div 
          key={option.id}
          className="attachment-option" 
          onClick={() => handleOptionClick(option.id)}
        >
          <span className="attachment-icon">{option.icon}</span>
          <span>{option.label}</span>
        </div>
      ))}
    </div>
  );
}

export default AttachmentMenu; 